import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NextStepPayload, OrderingStepperState, StepperKeysEnum } from './types';

const initialState: OrderingStepperState = {
  step: StepperKeysEnum.DELIVERY_TYPE,
};

const orderingStepperSlice = createSlice({
  name: 'orderingStepper',
  initialState,
  reducers: {
    changeStep: (state, action: PayloadAction<NextStepPayload>) => ({
      ...state,
      step: action.payload.nextStep,
    }),
    resetStep: (state) => ({
      ...state,
      step: StepperKeysEnum.DELIVERY_TYPE,
    }),
  },
});

export default orderingStepperSlice;
